import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { COLA_STATUS } from './colaEnums';
import findField from './findField';
import getColaField from './getColaField';
import processField from './processField';
export default function colaRequest(_x, _x2, _x3, _x4) {
  return _colaRequest.apply(this, arguments);
}

function _colaRequest() {
  _colaRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(qnaAnswer, msg, webapiUrl, headers) {
    var foundFields;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            foundFields = findField(qnaAnswer.answer);

            if (!(foundFields.length > 0)) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return", foundFields.reduce( /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(answer, foundField) {
                var useAnswer, colaAnswer, field, newAnswer;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        useAnswer = answer;

                        if (!answer.then) {
                          _context.next = 5;
                          break;
                        }

                        _context.next = 4;
                        return answer;

                      case 4:
                        useAnswer = _context.sent;

                      case 5:
                        if (!(useAnswer.status === COLA_STATUS.OK)) {
                          _context.next = 13;
                          break;
                        }

                        _context.next = 8;
                        return getColaField(foundField, webapiUrl, headers);

                      case 8:
                        colaAnswer = _context.sent;
                        field = processField(foundField, colaAnswer, msg);
                        newAnswer = {
                          status: colaAnswer.status,
                          processedMessage: ''
                        };

                        if (colaAnswer.status === COLA_STATUS.OK) {
                          newAnswer.processedMessage = useAnswer.processedMessage.replace(foundField, field);
                        } else if (colaAnswer.status === COLA_STATUS.ERROR) {
                          newAnswer.processedMessage = field;
                        } else if (colaAnswer.status === COLA_STATUS.ADDITIONAL_UNAVAILABLE) {
                          newAnswer.processedMessage = msg('chatBot.additionalUnavailable');
                        }

                        return _context.abrupt("return", newAnswer);

                      case 13:
                        return _context.abrupt("return", answer);

                      case 14:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x5, _x6) {
                return _ref.apply(this, arguments);
              };
            }(), {
              processedMessage: qnaAnswer.answer,
              status: COLA_STATUS.OK
            }));

          case 3:
            return _context2.abrupt("return", null);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _colaRequest.apply(this, arguments);
}